import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PeppolConnection } from '../interfaces/peppol-enrollment.interface';

export const PEPPOL_CONNECTION_API = new InjectionToken<PeppolConnectionApi>(
  'PEPPOL_CONNECTION_API',
);

export interface PeppolConnectionApi {
  getConnection(organization?: string): Observable<PeppolConnection>;
}
